import {
	PROJECT_DIRECTORY_ARCHIVED_PAGE,
	PROJECT_DIRECTORY_ARCHIVED_PATH,
	PROJECT_DIRECTORY_FOLLOWING_PAGE,
	PROJECT_DIRECTORY_FOLLOWING_PATH,
	PROJECT_DIRECTORY_PAGE,
	PROJECT_DIRECTORY_PATH,
} from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const projectDirectoryRoute = createGlobalRoute({
	exact: true,
	name: PROJECT_DIRECTORY_PAGE,
	path: PROJECT_DIRECTORY_PATH,
	capabilities: ['projects_app:access'],
	subproduct: 'townsquare-projects',
	enableRestrictedFallback: true,
	nav4Layout: 'expanded',
});

export const projectNoWorkspaceDirectoryRoute = createGlobalRoute({
	exact: true,
	name: PROJECT_DIRECTORY_PAGE,
	path: PROJECT_DIRECTORY_PATH,
	resources: [],
	subproduct: 'townsquare-projects',
});

export const projectDirectoryFollowingRoute = createGlobalRoute({
	exact: true,
	name: PROJECT_DIRECTORY_FOLLOWING_PAGE,
	path: PROJECT_DIRECTORY_FOLLOWING_PATH,
	capabilities: ['projects_app:access'],
	subproduct: 'townsquare-projects',
	enableRestrictedFallback: true,
	nav4Layout: 'expanded',
});

export const projectDirectoryArchivedRoute = createGlobalRoute({
	exact: true,
	name: PROJECT_DIRECTORY_ARCHIVED_PAGE,
	path: PROJECT_DIRECTORY_ARCHIVED_PATH,
	capabilities: ['projects_app:access'],
	subproduct: 'townsquare-projects',
	enableRestrictedFallback: true,
	nav4Layout: 'expanded',
});
